module.exports = __webpack_public_path__ + "img/course_area.61f25968.svg";